export class Carousels{
	init(){
		var carouselThumbs	= $('.gallery-thumbs .owl-carousel'),
			carouselZoom 	= $('.gallery-category--zoom-slider .owl-carousel'),
			carouselOffers 	= $('.gallery-category--offers .owl-carousel'),
			pluginFlag 		= carouselOffers.length || carouselThumbs.length || carouselZoom.length;

		if(pluginFlag)
			if(carouselOffers)
				this.carouselOffers(carouselOffers);
			if(carouselThumbs)
				this.carouselThumbs(carouselThumbs);
			if(carouselZoom)
				this.carouselZoom(carouselZoom);
	}
	carouselOffers(carousel){
		carousel.owlCarousel({
			items: 3,
			slideBy: 1,
			loop: true,
			mouseDrag: true,
			autolay: false,
			nav: true,
			dots: true,
			thumbs: false,
			stagePadding: 30,
			margin: 30,
	    	navText: ['<span class="arrow arrow--prev"></span>', '<span class="arrow arrow--next"></span>'],
	    	responsive: {
		        0: {
		          items: 1
		        },
		        641: {
		          items: 2
		        },
		        1024: {
		          items: 3
		        }
		    }
		})
	}

	carouselThumbs(carousel){
		carousel.owlCarousel({
	    items: 1,
	    loop: true,
	    margin: 0,
	    nav: true,
	    navText: ['<img src="./assets/images/icons/arrow-l.svg" alt="" />', '<img src="./assets/images/icons/arrow-r.svg" alt="" />'],
	    dots: false,
	    thumbs: true,
	    thumbsPrerendered: true,
	    onChanged: function(e){
	    	var itemsLength = this._items.length;

	    	var $slider 					= this.$element.parents('.gallery-thumbs'),
	    			$slides 					= $slider.find('.owl-carousel .owl-item:not(.cloned)'),
	    			$thumbs 					= $slider.find('.gallery-thumbs__thumbs'),
	    			$thumbsContainer 	= $thumbs.find('.gt-thumbs__container'),
	    			$thumbsList 			= $thumbs.find('.owl-thumbs');

				var thumbWidth = $thumbsList.find('.owl-thumb-item').outerWidth(true),
						thumbsListWidth = thumbWidth * itemsLength,
						thumbsContainerWidth = $thumbsContainer.width();

				var thumbsOuterWidth = thumbsListWidth - thumbsContainerWidth,
						thumbsPositionPart = thumbsOuterWidth / itemsLength;
	    	
	    	var currentPosition = $thumbsList.find('.owl-thumb-item.active').index(),
	    			currentSlide = $slides.eq(currentPosition);
	    			
	    	if(thumbsOuterWidth > 0){
		    	$thumbsList.css({
		    		'-webkit-transform': 'translateX('+((-currentPosition + 1) * thumbsPositionPart)+'px)',
		    		'-mox-transform': 'translateX('+((-currentPosition + 1) * thumbsPositionPart)+'px)',
		    		'transform': 'translateX('+((-currentPosition + 1) * thumbsPositionPart)+'px)'
		    	});
		    }

	    	setTimeout(function(){
	    		currentSlide.addClass('active');
	    	});
	    }
		});
	}

	carouselZoom(carousel) {
    carousel.owlCarousel({
	    stagePadding: 40,
	    loop: true,
	    autoWidth: false,
	    center: true,
	    margin: 0,
	    responsive: {
	        0: {
	          items: 3,
	          autoWidth: true
	        },
	        320: {
	          items: 3
	        },
	        641: {
	          items: 3,
	          autoWidth: true,
	          center: false
	        },
	        1024: {
	          items: 4,
	          center: true,
	          autoWidth: true
	        },
	        1350: {
	          items: 7,
	          center: true,
	          autoWidth: true
	        }
	    }
    });

		
		carousel.find('.owl-item').on('click', function() {
			var $this = $(this),
				index = $this.index(),
				itemsLength = $this.siblings('.owl-item').length,
				itemsHandler = $this.closest('.owl-stage-outer'),
				activeItems = $this.closest('.gallery-category--zoom-slider').find('.active');

			if($this.hasClass('zoomed')){
				$this.removeClass('zoomed');
			}else if(($this.prev().hasClass('active') && $this.next().hasClass('active')) || (!$this.prev().hasClass('active') && !$this.next().hasClass('active'))){
				$('.zoomed').removeClass('zoomed');
				$this.addClass('zoomed');
			}else if($this.prev().hasClass('active') && !$this.next().hasClass('active')){
				carousel.trigger('next.owl.carousel', [500]);
				$('.zoomed').removeClass('zoomed');
				$this.addClass('zoomed');
			}else if(!$this.prev().hasClass('active') && $this.next().hasClass('active')){
				carousel.trigger('prev.owl.carousel', [500]);
				$('.zoomed').removeClass('zoomed');
				$this.addClass('zoomed');
			}
		});
	}
}